import { DataFeedsFormSection } from '../common/DataFeedsFormSection';
import { BackgroundOverlay } from './formFields/BackgroundOverlay';
import { MobileInbox } from './formFields/MobileInbox';
import { Position } from './formFields/Position';
import { PresetAnimations } from './formFields/PresetAnimations';
import { RawDataFormSection } from './formFields/RawDataFormSection';
import { MessageFormat } from './formFields/MessageFormat';
import { SettingsSectionHeader } from '../common';
import { displayContent } from '../common/content';

export const AppAndBrowserFields = () => {
  return (
    <>
      <SettingsSectionHeader>{displayContent.headerContent}</SettingsSectionHeader>
      <MessageFormat />
      <MobileInbox />
      <DataFeedsFormSection />

      <SettingsSectionHeader>{displayContent.headerBehavior}</SettingsSectionHeader>
      <Position />
      <PresetAnimations />
      <BackgroundOverlay />
      <RawDataFormSection />
    </>
  );
};
